import { render, staticRenderFns } from "./NewImport.vue?vue&type=template&id=555bd955&scoped=true&"
import script from "./NewImport.vue?vue&type=script&lang=js&"
export * from "./NewImport.vue?vue&type=script&lang=js&"
import style0 from "./NewImport.vue?vue&type=style&index=0&id=555bd955&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "555bd955",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VForm } from 'vuetify/lib/components/VForm';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VCheckbox,VFileInput,VForm,VSelect})
